import _Fab from "@material-ui/core/esm/Fab";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import ClearIcon from '@material-ui/icons/Clear';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { DEFAULT_BUTTON } from '../../../../../../../../constants/styles';
import classes from './design-note.scss';
const useStyles = makeStyles(() => ({
  button: _objectSpread({}, DEFAULT_BUTTON, {
    width: '37px',
    height: '27px',
    minHeight: '27px',
    marginTop: '6px',
    fontSize: '12px',
    padding: 0,
    margin: 0,
    borderRadius: '50px'
  }),
  icon: {
    fontSize: '15px'
  }
}));
const DesignAttachmentsItem = ({
  name,
  src,
  onFileDelete
}) => {
  // @ts-ignore
  const myStyles = useStyles();
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement("div", {
      className: classes.attachment
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.filenameWrapper
    }, src ? /*#__PURE__*/React.createElement("a", {
      href: src,
      download: true,
      title: name,
      className: classnames(classes.filename, classes.actionable)
    }, name) : /*#__PURE__*/React.createElement("span", {
      title: name,
      className: classes.filename
    }, name), /*#__PURE__*/React.createElement(_Fab, {
      className: myStyles.button,
      onClick: onFileDelete,
      color: "default"
    }, /*#__PURE__*/React.createElement(ClearIcon, {
      className: myStyles.icon
    }))))
  );
};
export default DesignAttachmentsItem;